var e = function e(_e) {
  return _e && _e.replace ? _e.replace(/([\uD800-\uDBFF][\uDC00-\uDFFF])/g, "") : _e;
};
export { e as removeEmojis };